import categories from './categories'

const isInvalid = ({ parameters }) => {
  return parameters.slug === 'blog' || !categories.isInvalid({ parameters })
}

export default { isInvalid }
